import React, { Component } from 'react';
import { Container, Row, Col, Input, Table, Button } from 'reactstrap';
import Session from '../auth/Session';
import AdminFunctions from './AdminFunctions';
import AuthFunctions from '../services/AuthService';
import utilities from '../util/utilities';
import { FaSort } from 'react-icons/fa'
import '../layout/site.css';

export class Clients extends Component {
    static displayName = Clients.name;

    constructor(props) {
        super(props);

        this.state = {
            search: null,
            clients: [],
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
            userClient: {}
        };

        window.addEventListener('resize', this.setWindowDimensions);        
    }

    async componentDidMount() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        var isAdmin = false;
        var isWrite = false;
        var isHomeL = false;
        var isComps = false;
        if (isAuthenticated) {
            isAdmin = await AdminFunctions.isAdminAsync();
            if (!isAdmin) {
                isWrite = await AdminFunctions.isRole("Write");
                isHomeL = await AdminFunctions.isRole("Home Limited");
                isComps = await AdminFunctions.isRole("Comps");
            } else {
                isWrite = true;
                isHomeL = true;
                isComps = await AdminFunctions.isRole("Comps");
            }

        }

        if (!isHomeL) {
            this.props.history.push('/accessdenied');
        } else {
            this.setWindowDimensions();
            this.getClients();
        }
        this.setState({ authenticated: isAuthenticated, admin: isAdmin, loading: false, write: isWrite, homeL: isHomeL, comps: isComps });
    }


    render() {
        return (
            <div>
                <Container className='container-main'>
                    <Row>
                        <Col>
                            <h3>Client Selection</h3>
                        </Col>
                    </Row>
                    <Row className='row-20'>
                        <Col>
                            <Table >

                                <tbody>
                                    {this.state.clients.map((client,  i) => {
                                        return (
                                            <tr
                                                key={client.cl_id}
                                                
                                                className="noBoarder"
                                            >
                                                <td className="noBoarder">
                                                    <Button
                                                        color='primary'
                                                        onClick={() => this.handleRowClick(client.cl_id)}
                                                        className="g-orange-bg g-orange-c g-orange-button gButtonVarWidth"
                                                        style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                                        disabled={this.state.loading === true ? true : false}
                                                    >
                                                        {client.cl_name}
                                                    </Button>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                    {this.state.comps === true && (
                                        <tr
                                            className="noBoarder"
                                        >
                                            <td className="noBoarder">
                                                <Button
                                                    color='primary'
                                                    onClick={() => this.handleCompsClick()}
                                                    className="g-orange-bg g-orange-c g-orange-button gButtonVarWidth"
                                                    style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                                    disabled={this.state.loading === true ? true : false}
                                                >
                                                    Comps
                                                </Button>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>                    
                </Container>
            </div>
        )
    }

    async getClients() {
        const token = Session.getToken();

        const response = await fetch(`api/Clients/ShowAllClients`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`}
        });
        const data = await response.json();
        this.setState({ clients: data });
    }

    setWindowDimensions = () => {
        this.setState({
            height: window.innerHeight,
            width: window.innerWidth
        });
    };

    async handleRowClick(clientId) {
        const token = Session.getToken();
        var dto = { cl_id: clientId, cl_name: '', logoLocation: ''}
        const response = await fetch('api/Clients/SetClient', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(dto)
        }).then(function (f) {
            window.location.href = '/Lease/LeaseSearch'
        })
        
    }


    async handleCompsClick(clientId) {
        const token = Session.getToken();
        //DEMO is client 2
        var dto = { cl_id: 2, cl_name: '', logoLocation: '' }
        const response = await fetch('api/Clients/SetClient', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(dto)
        }).then(function (f) {
            window.location.href = '/Comps/Index'
        })

    }
}